<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex xs12>
                <span style="font-size: 48px">Rencontrez l'équipe</span>
            </v-flex>

        </v-layout>
        <v-layout row wrap class="mt-4">
            <v-flex xs12 md6 flexbox d-flex class="mt-3" v-for="(item, index) in team" :key="index">
                <v-layout row wrap>
                    <v-flex xs5 md5>
                        <v-card style="border-radius: 10px">
                            <v-card-media height="200px" :src="item.photo">
                            </v-card-media>
                        </v-card>
                    </v-flex>
                    <v-flex xs7 md7>
                        <span style="font-size: 32px">{{item.names}}</span><br>
                        <span style="font-size: 18px" class="blue-grey--text darken-4">{{item.position}}</span>
                        <p style="font-size: 16px">{{item.biography}}</p>
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
  export default {
    data () {
      return {
        team: [
          { names: 'Winner Musole', position: 'PDG', biography: 'Il est le co-fondateur et actuel du PDG de Ligablo Food, mais aussi directeur financier chez Pynlabs Uganda. Winner vient d’obtenir son baccalauréat en informatique de International University of East Africa, Kampala, en Ouganda avec un mémoire orienté sur le marché boursier.', photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fwinner.jpg?alt=media&token=04e244e3-ab0b-4060-868d-6f22e14b49a6', twitterRef: 'https://twitter.com/musolemasu', twitterName: 'MusoleMasu' },
          { names: 'Gueldany Panzu', position: 'Associé-Gérant', biography: "Il est co-fondateur et l'actuel gérant de Ligablo Food. Gueldany est un analyste programmeur, étudiant en Informatique à l'université de Kinshasa et Entrepreneur.", photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fgueldany_optimized.jpeg?alt=media&token=daed96f8-cb01-4b28-aa0d-d24c8073f7e1', twitterRef: 'https://twitter.com/gueldany', twitterName: 'GuelanyPanzu' },
          { names: 'Delphine Musole', position: 'Chargée des finances', biography: 'Co-fondatrice de Ligablo Food. Delphine Musole fait la Science economique à Université Federal de Rio de Janeiro au Bresil.', photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fdelphine.jpeg?alt=media&token=68073003-69f5-4f92-b773-f56a4ee38e10', twitterRef: 'https://twitter.com/musolemasu', twitterName: 'DelphineMusole' },
          { names: 'Sebastien Wendji', position: 'Conseiller', biography: "Sebastien Wendji est un jeûne  entrepreneur congolais, co-fondateur de LigabloFood et actuellement étudiant de la faculté des sciences pharmaceutiques de l'université de Kinshasa.", photo: 'https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/teamPhoto%2Fsebastien.jpg?alt=media&token=786815f8-82d8-4178-bc66-48d3d4633dc8', twitterRef: 'https://twitter.com/musolemasu', twitterName: 'DelphineMusole' }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Team.vue